$(function () {
    $(document).ready(function () {
        var filterForm = $('.locations__filters');

        $('#regionFilter').change(function () {

            var regionFilter = $(this);
            window.location.href = filterForm.attr("action") + "?region=" + regionFilter.val() + "#locationListingAnchor";

            //$.ajax({
            //    url: '/Location/GetCountryData',
            //    method: 'POST',
            //    data: { 'regionPath': $(this).val() },
            //    success: function (res) {
            //        var data = JSON.parse(res);

            //        // populate contry filter
            //        var container = regionFilter.parents('.region-filter').siblings('.country-filter');
            //        var filter = container.find('#countryFilter');

            //        console.log(data.defaultCountryText);

            //        // clear out old options except for default
            //        filter.html('<option value="' + regionFilter.val() + '">' + data.defaultCountryText + '</option>');

            //        var options = '';

            //        for (var i = 0; i < data.countries.length; i++) {
            //            options += '<option value="' + data.countries[i].NodeAliasPath + '">' + data.countries[i].CountryName + '</option>';
            //        }

            //        filter.append(options);

            //        // show filter
            //        container.show();

            //        // populate locations
            //        var loadMoreBtn = regionFilter.parents('.wt-location-listing-widget').find('.btn-load-more-locations');
            //        if (data.needsLazyLoading) {
            //            loadMoreBtn.show();
            //        }
            //        else {
            //            loadMoreBtn.hide();
            //        }

            //        var locationContainer = regionFilter.parents('.wt-location-listing-widget').find('.locations');
            //        InitLocationsListing(data.locations, locationContainer);
            //    }
            //});
        });

        $('#countryFilter').change(function () {

            var countryFilter = $(this);
            var regionFilter = $('#regionFilter');

            window.location.href = filterForm.attr("action") + "?region=" + regionFilter.val() + "&country=" + countryFilter.val() + "#locationListingAnchor";

            //$.ajax({
            //    url: '/Location/GetLocationData',
            //    method: 'POST',
            //    data: { 'countryPath': countryFilter.val() },
            //    success: function (res) {
            //        var data = JSON.parse(res);

            //        // populate locations
            //        var loadMoreBtn = countryFilter.parents('.wt-location-listing-widget').find('.btn-load-more-locations');
            //        if (data.needsLazyLoading) {
            //            loadMoreBtn.show();
            //        }
            //        else {
            //            loadMoreBtn.hide();
            //        }

            //        var locationContainer = countryFilter.parents('.wt-location-listing-widget').find('.locations');
            //        InitLocationsListing(data.locations, locationContainer);
            //    }
            //});
        });
    });
});

//function InitLocationsListing(locations, container) {
//    var locationsHtml = '';

//    if (locations.length != 0) {
//        for (var i = 0; i < locations.length; i++) {
//            locationsHtml += '<div class="locations-result-load load-' + i + (i > 0 ? " row-hidden was-hidden" : "") + '">';

//            for (var l = 0; l < locations[i].length; l++) {
//                locationsHtml += '<div class="location">';

//                if (locations[i][l].LocationImage != null) {
//                    locationsHtml += '<div class="col-12 col-md-4"><div class="location__image">';
//                    locationsHtml += '<img src="' + locations[i][l].LocationImage.DirectUrlPreview + '" alt="' + locations[i][l].LocationImage.AltText + '" />';
//                    locationsHtml += '</div></div>';
//                }

//                locationsHtml += '<div class="col-12' + (locations[i][l].LocationImage != null ? " col-md-8" : "") + '">';
//                locationsHtml += '<div class="location__content"><div class="name">' + locations[i][l].LocationName + '</div>';
//                locationsHtml += '<div class="address">';

//                if (CheckIsNotNullOrEmpty(locations[i][l].LocationCompanyName)) {
//                    locationsHtml += '<div class="company-name">' + locations[i][l].LocationCompanyName + '</div>';
//                }

//                if (CheckIsNotNullOrEmpty(locations[i][l].LocationAddressLine1)) {
//                    locationsHtml += '<div class="address-1">' + locations[i][l].LocationAddressLine1 + '</div>';
//                }

//                if (CheckIsNotNullOrEmpty(locations[i][l].LocationAddressLine2)) {
//                    locationsHtml += '<div class="address-2">' + locations[i][l].LocationAddressLine2 + '</div>';
//                }

//                locationsHtml += '<div class="city-state-zip">';

//                if (CheckIsNotNullOrEmpty(locations[i][l].LocationCity)) {
//                    locationsHtml += '<span class="city">' + locations[i][l].LocationCity + '</span>';
//                }

//                if (CheckIsNotNullOrEmpty(locations[i][l].LocationState)) {
//                    locationsHtml += '<span class="state">, ' + locations[i][l].LocationState + '</span>';
//                }

//                if (CheckIsNotNullOrEmpty(locations[i][l].LocationZipCode)) {
//                    locationsHtml += '<span class="zip"> ' + locations[i][l].LocationZipCode + '</span>';
//                }

//                locationsHtml += '</div>';

//                if (CheckIsNotNullOrEmpty(locations[i][l].LocationCountry)) {
//                    locationsHtml += '<div class="country">' + locations[i][l].LocationCountry + '</div>';
//                }

//                locationsHtml += '</div><div class="contact-info">';

//                if (CheckIsNotNullOrEmpty(locations[i][l].LocationPhone)) {
//                    locationsHtml += '<div class="phone"><strong>Tel:</strong> ' + locations[i][l].LocationPhone + '</div>';
//                }

//                if (CheckIsNotNullOrEmpty(locations[i][l].LocationEmail)) {
//                    locationsHtml += '<div class="email"><strong>Email:</strong> ' + locations[i][l].LocationEmail + '</div>';
//                }

//                locationsHtml += '</div>';

//                if (CheckIsNotNullOrEmpty(locations[i][l].LocationDescription)) {
//                    locationsHtml += '<div class="additional-info"><div class="heading">Additional Information:</div>';
//                    locationsHtml += '<div class="content">' + locations[i][l].LocationDescription + '</div></div>';
//                }

//                locationsHtml += '</div></div></div>';
//            }

//            locationsHtml += '</div>';
//        }
//    }
//    else {
//        locationsHtml += '<div class="no-results">No results found.</div>';
//    }

//    container.html(locationsHtml);
//}


//function CheckIsNotNullOrEmpty(obj) {
//    if (obj != null && obj != "") return true;

//    return false;
//}